import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { Overlay } from "react-bootstrap";

import DateHelper from "DateHelper";
import ThemeHelper from "ThemeHelper";
import textWidth from "text-width";

import { setComputedRoundTripData } from "../../../Actions/RelatedInfoPanelActions/RiPanelActions";
import GraphType from "../../../Constants/GraphType";

function Transactions({
  buyPoints,
  sellPoints,
  computedUnitCostNodes,
  roundTripData,
  isTransactionsVisible,
  isRoundtripShadingVisible,
  HiLowPoints,
  setComputedRoundTripData,
  majorPeriodicity
}) {
  const today = new Date();
  const allPoints = HiLowPoints.allPoints
  const currDate = allPoints && allPoints.length > 0 && allPoints[0] && allPoints[0].Date ? allPoints[0].Date : today;

  return isTransactionsVisible && <div style={{ position: "absolute", height: '100%', width: '100%', pointerEvents: 'none' }}>
    {computedUnitCostNodes && <DrawSVGCostLine
      source={computedUnitCostNodes}
      color={ThemeHelper.getThemedBrush("fff000")}
      currDate={currDate}
    />}
    {isRoundtripShadingVisible && roundTripData && <DrawRoundTripHighlight
      source={roundTripData}
      colorGreen={ThemeHelper.getThemedBrush("greenNode")}
      colorRed={ThemeHelper.getThemedBrush("redNode")}
      currDate={currDate}
      setComputedRoundTripData={setComputedRoundTripData}
      majorPeriodicity={majorPeriodicity}
    />}
    {sellPoints && <DrawSVGArrows
      source={sellPoints}
      color={ThemeHelper.getThemedBrush("redNode")}
      currDate={currDate}
      sell={true}
    />}
    {buyPoints && <DrawSVGArrows
      source={buyPoints}
      color={ThemeHelper.getThemedBrush("greenNode")}
      currDate={currDate}
      sell={false}
    />}

  </div>

}

const mapStateToProps = (state) => {
  const { HiLowPoints } = state.DatagraphReducers.PriceChartReducer;
  const { majorPeriodicity } = state.DatagraphReducers.DataGraphReducer;

  const { isCurrencyConversionChecked } = state.currency;
  const { computedTransactionData, transactionsSettings, computedRoundTripsChartDatas, computedUnitCostNodes } = state.RelatedInfoPanelReducers.RiPanelTransactionsReducer;
  const { isTransactionsVisible, isRoundtripShadingVisible } = transactionsSettings;
  return {
    buyPoints: computedTransactionData.buyPoints,
    sellPoints: computedTransactionData.sellPoints,
    computedUnitCostNodes: computedUnitCostNodes,
    roundTripData: [...computedRoundTripsChartDatas],
    isTransactionsVisible,
    isRoundtripShadingVisible,
    HiLowPoints,
    isCurrencyConversionChecked,
    majorPeriodicity
  };
}

const mapDispatchToProps = (dispatch) => ({
  setComputedRoundTripData: (computedRoundTripData) => dispatch(setComputedRoundTripData(computedRoundTripData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);

function drawBuyArrows(arrowData, currDate) {
  if (arrowData === undefined || arrowData === null) {
    return " ";
  }
  let pathData = "";
  if (arrowData.yAxis !== undefined) {
    if (!isNaN(arrowData.yAxis) && !isNaN(arrowData.xAxis)) {
      if (arrowData.Date <= currDate) {
        pathData += " M " +
          (arrowData.xAxis - 2) +
          " " +
          arrowData.yAxis +
          " L " +
          (arrowData.xAxis - 8) +
          " " +
          (arrowData.yAxis + 3) +
          " L " +
          (arrowData.xAxis - 5) +
          " " +
          (arrowData.yAxis + 6) +
          " L " +
          (arrowData.xAxis - 2) +
          " " +
          arrowData.yAxis +
          " L " +
          (arrowData.xAxis - 16) +
          " " +
          (arrowData.yAxis + 15);
      }
    }
  }
  return pathData;
}
function drawSellArrows(arrowData, currDate) {
  if (arrowData === undefined || arrowData === null) {
    return " ";
  }
  let pathData = "";
  if (arrowData.yAxis !== undefined) {
    if (!isNaN(arrowData.yAxis) && !isNaN(arrowData.xAxis)) {
      if (arrowData.Date <= currDate) {
        pathData += " M " +
          (arrowData.xAxis + 2) +
          " " +
          arrowData.yAxis +
          " L " +
          (arrowData.xAxis + 5) +
          " " +
          (arrowData.yAxis - 6) +
          " L " +
          (arrowData.xAxis + 8) +
          " " +
          (arrowData.yAxis - 3) +
          " L " +
          (arrowData.xAxis + 2) +
          " " +
          arrowData.yAxis +
          " L " +
          (arrowData.xAxis + 16) +
          " " +
          (arrowData.yAxis - 15);
      }
    }
  }
  return pathData;
}
function drawCostLine(lineData, currDate) {
  if (lineData === undefined || lineData === null || lineData[0] === undefined || lineData.length < 1) {
    return " ";
  }
  let pathData = "";
  if (lineData[0].yAxis !== undefined) {
    lineData.map((obj) => {
      if (!isNaN(obj.yAxis) && !isNaN(obj.x1Axis) && !isNaN(obj.yAxis) && obj.x2Axis > 0) {
        if (DateHelper.setToMidnight(obj.endDate) <= DateHelper.setToMidnight(currDate)) {
          pathData += " M " +
            obj.x1Axis +
            " " +
            obj.yAxis +
            " L " +
            obj.x2Axis +
            " " +
            obj.yAxis;
        }
      }
    });
  }
  return pathData;
}

function DrawSVGArrows({ source, color, currDate, sell }) {

  const [tooltip, setTooltip] = useState({
    showBuySellTooltip: false,
    buySellTooltipX: 0,
    buySellTooltipY: 0,
    dataSource: null
  })


  function shoToolTip(data) {
    setTooltip({
      showBuySellTooltip: true,
      dataSource: data,
      buySellTooltipX: data.xAxis,
      buySellTooltipY: data.yAxis,
    })
  }

  function closeTooltip() {
    setTooltip({
      showBuySellTooltip: false,
      dataSource: null,
      buySellTooltipX: 0,
      buySellTooltipY: 0,
    })
  }
  const pathFunc = sell ? drawSellArrows : drawBuyArrows;
  return <>
    {tooltip.showBuySellTooltip && <BuySellTooltip
      buySellTooltipX={tooltip.buySellTooltipX}
      buySellTooltipY={tooltip.buySellTooltipY}
      source={tooltip.dataSource}
    />}
    <svg
      className="transactions-svg"
      height='100%'
      width='100%'
    >
      {source.map((data, index) => {
        return <path d={pathFunc(data, currDate)}
          data-disable-track-price="true"
          stroke={color}
          strokeWidth={1}
          fill={color}
          cursor="pointer"
          onMouseEnter={() => shoToolTip(data)}
          onMouseLeave={() => closeTooltip()}
          pointerEvents="stroke"
          key={index}
        />
      })}
    </svg>
  </>
}

function DrawSVGCostLine({ source, color, currDate }) {
  const pathData = drawCostLine(source, currDate);
  return (<svg
    className="svg transactions-svg transaction-linestyle"
    id="TransactionCostLineLayer"
    height='100%'
    width='100%'>
    <path
      d={pathData} data-disable-track-price="true"
      stroke={color}
      strokeWidth={2}
      strokeDasharray="2,2"
      fill={color}
      pointerEvents="none"
    >
    </path>
  </svg>);

}

const RoundTripInfoBoxWrapper = ({ hidePopup, width, data, maxWidth, tooltipPosition }) => {
  const popoverRef = useRef(null);
  let backgroundColor = ThemeHelper.getThemedBrush("E1E20FEFEF0");
  let grayText = ThemeHelper.getThemedBrush("scaleText");

  return <div
    className="roundtrip-infobox"
    ref={popoverRef}
    style={{
      ...tooltipPosition,
      position: 'absolute',
      width: width ? width : null,
      maxWidth: maxWidth,
      backgroundColor: backgroundColor,
      color: grayText,
      transform: 'translateX(-50%)'
    }}
    onMouseDown={(event) => event.nativeEvent?.stopImmediatePropagation()}
  >
    {(data && data.stick) &&
      <div
        className="close-button"
        style={{
          backgroundColor: backgroundColor,
        }}
        data-disable-track-price="true"
        onMouseDown={hidePopup}
      >
        <div className="close-icon">X</div>
      </div>
    }
    <div style={{ fontWeight: 'bold', marginBottom: '4px', textAlign: 'center' }}>{data.portfolioName}</div>
    <hr style={{ margin: '0 0 8px 0', border: 'none', borderTop: `1px solid ${grayText}` }} />
    <div>
      <span>Initial Weight: <b>{data.initialWeight.toFixed(2)}</b> %</span><br />
      <span>Max Weight: <b>{data.maxPortPerc.toFixed(2)}</b> %</span><br />
      <span>Transactions: <b>{data.noofTrades}</b></span>
    </div>
  </div>
}

const RoundTripInfoBox = ({ showPopup, hidePopup, target, roundTrip, maxWidth, placement, roundTripBounds, roundTripSVGRef, majorPeriodicity }) => {
  const { x, y, width, height } = roundTripBounds;
  let svgBounds
  if (roundTripSVGRef.current) {
    svgBounds = roundTripSVGRef.current.getBoundingClientRect();
  }
  else {
    svgBounds = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  const yText = roundTrip.percGain > 0 ? "+" + roundTrip.percGain.toFixed(2) + "%" : roundTrip.percGain.toFixed(2) + " %";
  // calculate the width of the x and y values
  const xWidth = textWidth(roundTrip.xText, { family: "calibri", size: 14 });
  const yWidth = textWidth(yText, { family: "calibri", size: 14 });

  // Y-Axis Label (Centered Below)
  let xLabelX = (Math.max(0, x) + Math.min(svgBounds.width, x + width)) / 2; // Center of visible area
  let xLabelY = roundTrip.unitCost > roundTrip.sellPrice ? y + height + 16 : y + 16; // Slightly below the rectangle

  // label is beyond left of chart
  if (xLabelX - (xWidth / 2) - 4 < 0) {
    xLabelX = (xWidth / 2) + 4
  }
  // label is beyond right of chart
  if (xLabelX + (xWidth / 2) + 4 > svgBounds.width) {
    xLabelX = svgBounds.width - (xWidth / 2) - 4
  }
  // label is beyond bottom of chart
  if (xLabelY + 5 > svgBounds.height) {
    xLabelY = Math.min(svgBounds.height - 12, y - height - 10)
  }
  // label is beyond top of chart(this case does not occur)
  if (xLabelY - 12 < 0) {
    xLabelY = 12
  }

  // Y-Axis Label (Centered Right)
  let yLabelX = x + width + (yWidth / 2) + 6; // Slightly to the right
  // let yLabelY = y + height / 2 + 6; // Centered vertically
  let yLabelY
  if (height >= 0) {
    yLabelY = (Math.max(0, y) + Math.min(svgBounds.height, y + height)) / 2 + 6; // Center of visible area
  } else {
    yLabelY = (Math.max(0, y + height) + Math.min(svgBounds.height, y)) / 2 + 6; // Center of visible area
  }

  // label is beyond left of chart(this case does not occur)
  if (yLabelX - (yWidth / 2) - 4 < 0) {
    yLabelX = (yWidth / 2) + 4
  }
  // label is beyond right of chart
  if (yLabelX + (yWidth / 2) + 4 > svgBounds.width) {
    yLabelX = Math.min(svgBounds.width - (yWidth / 2) - 4, x + width - (yWidth / 2) - 4)
    yLabelX = yLabelX - (yWidth / 2) - 4 < x ? x - (yWidth / 2) - 6 : yLabelX
  }
  // label is beyond bottom of chart
  if (yLabelY + 5 > svgBounds.height) {
    yLabelY = svgBounds.height - 5
  }
  // label is beyond top of chart
  if (yLabelY - 12 < 0) {
    yLabelY = 12
  }

  // tooltip position
  const tooltipHeight = 100; // approximate height of the tooltip
  let tooltipPosition = {}
  tooltipPosition.left = svgBounds.left + xLabelX;
  const yTop = height >= 0 ? y : y + height;
  const showBelow = height >= 0 ? (y - tooltipHeight) < 0 : (y + height - tooltipHeight) < 0;

  if (showBelow) {
    tooltipPosition.top = svgBounds.top + xLabelY + 6
  } else {
    tooltipPosition.bottom = window.innerHeight - (svgBounds.top + yTop - 5)
  }

  return (
    <>
      <g>
        {/* rect for gray background of the label text */}
        <rect x={xLabelX - (xWidth / 2) - 4} y={xLabelY - 12} width={xWidth + 8} height="16" fill="gray" stroke="#656565" strokeWidth={1} />
        <text x={xLabelX} y={xLabelY} className="round-trip-label">
          {roundTrip.xText}
        </text>
        {/* rect for gray background of the label text */}
        <rect x={yLabelX - (yWidth / 2) - 4} y={yLabelY - 12} width={yWidth + 8} height="16" fill="gray" stroke="#656565" strokeWidth={1} />
        <text x={yLabelX} y={yLabelY} className="round-trip-label">
          {yText}
        </text>
      </g>

      <Overlay
        key={roundTrip.length}
        show={showPopup}
        target={target}
        style={{
          marginTop: '10px',
        }}
        placement={placement}
        container={document.body}
        containerMargin={10}
      >
        <RoundTripInfoBoxWrapper
          hidePopup={hidePopup}
          maxWidth={maxWidth}
          width="fit-content"
          data={roundTrip}
          tooltipPosition={tooltipPosition}
        />
      </Overlay>
    </>
  );
}

function rectanglePath(x, y, height, width) {
  return `M ${x} ${y} v ${height} h ${width} v ${-height} z`
}

function DrawRoundTripHighlight({ source, colorGreen, colorRed, currDate, setComputedRoundTripData, majorPeriodicity }) {
  const roundTripRefs = useRef([]);
  const roundTripSVGRef = useRef(null); // Create a ref for the SVG element

  const handleCloseClick = (event, index) => {
    let newRoundTripData = source
    newRoundTripData[index].showBox = false
    newRoundTripData[index].stick = false
    setComputedRoundTripData(newRoundTripData)
  };

  const handleMouseLeave = (e, index) => {
    // showbox- false if stick is false
    let newRoundTripData = source
    if (!source[index].stick) {
      newRoundTripData[index].showBox = false
    }
    setComputedRoundTripData(newRoundTripData)
  }
  const handleMouseOver = (e, index) => {
    // showbox true if stick is false
    let newRoundTripData = source
    if (source[index].stick) {
      return;
    }
    newRoundTripData[index].showBox = true
    setComputedRoundTripData(newRoundTripData)
  }
  const handleMouseDown = (e, index) => {
    // showbox, stick true
    let newRoundTripData = source
    if (source[index].stick) {
      return;
    }
    newRoundTripData[index].stick = true
    newRoundTripData[index].showBox = true
    setComputedRoundTripData(newRoundTripData)
  }
  return (<svg
    className="svg transactions-svg transaction-linestyle"
    id="TransactionRoundTripLayer"
    height='100%'
    width='100%'
    ref={roundTripSVGRef}
  >
    {source.map((roundTrip, index) => {
      if (DateHelper.setToMidnight(roundTrip.endDate) <= DateHelper.setToMidnight(currDate)) {
        const absHeight = Math.abs(roundTrip.y2Axis - roundTrip.y1Axis)
        const x = roundTrip.x1Axis
        const y = roundTrip.y1Axis
        const width = Math.abs(roundTrip.x2Axis - roundTrip.x1Axis)
        const height = roundTrip.unitCost > roundTrip.sellPrice ? absHeight : -absHeight
        const rect = rectanglePath(x, y, height, width)

        return (
          <g key={index}>
            <path
              id={`round-trip-highlight-${index}`}
              ref={(el) => (roundTripRefs.current[index] = el)}
              d={rect}
              data-disable-track-price="true"
              fill={roundTrip.percGain < 0 ? colorRed : colorGreen}
              stroke="transparent"
              strokeWidth="2px"
              cursor="pointer"
              opacity="0.2"
              onFocus={(e) => handleMouseOver(e, index)}
              onMouseDown={(e) => handleMouseDown(e, index)}
              onMouseOver={(e) => handleMouseOver(e, index)}
              onMouseLeave={(e) => handleMouseLeave(e, index)}
              pointerEvents="visible"
            />
            {
              roundTrip.showBox &&
              <RoundTripInfoBox
                showPopup={roundTrip.showBox}
                hidePopup={(e) => { handleCloseClick(e, index) }}
                roundTrip={roundTrip}
                target={roundTripRefs.current[index]}
                placement="top"
                maxWidth="200px"
                roundTripBounds={{ x, y, width, height }}
                roundTripSVGRef={roundTripSVGRef}
                majorPeriodicity={majorPeriodicity}
              >
              </RoundTripInfoBox>
            }

          </g>)
      }
      else return null
    })}

  </svg>);

}

function BuySellTooltip({ buySellTooltipX, buySellTooltipY, source }) {
  const textStyle = {
    backgroundColor: ThemeHelper.getThemedBrush("E1E20FEFEF0"),
    left: buySellTooltipX,
    top: buySellTooltipY + 25,
  };
  let grayText = ThemeHelper.getThemedBrush("scaleText")
  return <div className="buy-sell-tooltip" style={textStyle}>
    <table>
      <tbody>
        {source.transactions.map((transaction, index) => {
          return <tr key={index}>
            <td>
              <div style={{ marginLeft: "8px", color: "gray", width: 'auto', textAlign: "left", margin: '0px 5px' }}>
                {DateHelper.getDateString(new Date(transaction.Date))} ({transaction.Action})
              </div>
            </td>
            <td>
              <div style={{ textAlign: "left", color: grayText, width: 'auto', margin: '0px 5px' }}>
                {transaction.PRICE.toFixed(2)}
              </div>
            </td>
          </tr>
        })}
      </tbody>
    </table>
  </div>
}